<div class="content-wrapper d-print-none">
    <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">Man Power Requests</h4>
                    <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                    </div>
                    <div class="table-responsive pt-3">
                        <nz-table #ManPowerTable [nzData]="Requests" [nzPageSize]="50">
                            <thead>

                                <tr>
                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Request Date
                                    </th>
                                    
                                    <th>
                                        Requester Name
                                    </th>

                                    <th>
                                        Requester Designation
                                    </th>

                                    <th>
                                        Required Role
                                    </th>

                                    <th>
                                        Created By
                                    </th>

                                   <th>
                                        Requester Function
                                    </th>

                                    <th>
                                        Location
                                    </th>

                                    <th *ngIf="isShowRejectionMessage">
                                        Rejection Message
                                    </th>

                                    <th>
                                        Status
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of ManPowerTable.data; let i = index ;">

                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{ data.createdDate | date: 'dd MMMM yyy' }}
                                    </td>

                                  

                                    <td>
                                        {{data.requesterName}}
                                    </td>

                                    <td>
                                        {{data.requesterDesignation}}
                                    </td>

                                    <td>
                                        {{data.jobTitle}}
                                    </td>

                                    <td>
                                        {{data.createdBy}}
                                        
                                    </td>

                                    <td>
                                        {{data.requesterFunction}}
                                    </td>

                                    <td>
                                        {{data?.location}}
                                    </td>

                                    <td  *ngIf="isShowRejectionMessage">
                                        {{data?.rejectionMessage}}
                                    </td>

                                    <td>
                                        <button [ngClass]="getStatusColor(data.status)"> {{data.status}}</button>
                                    </td>
                                    <td>

                                        <div class="dropdown">
                                            <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                       
                      </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">

                                                <a class="dropdown-item" (click)="open(data)">View</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" (click)="openapproval(data)">View Request Approval</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item"   nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                (nzOnConfirm)="beginCancel(data)" *ngIf="canCreateManpower &&  data.status =='Pending'" (nzOnCancel)="cancel()">Cancel Request</a>

                                            </div>
                                        </div>


                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
<!-- Context Menu  -->
<nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
        <li nz-menu-item>1st menu item</li>
        <li nz-menu-item>2nd menu item</li>
        <li nz-menu-divider></li>
    </ul>
</nz-dropdown-menu>


<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040" [nzVisible]="ViewManpowerRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

    <!-- Side swipe content -->
    <div class="row d-print-block" id="detailSection">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="row">
                    <div class="col">
                        <h5 class="card-title"> Manpower Request Details</h5>
                    </div>
                    <div class="col">
                        <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
                    </div>
                </div>


                <div class="card-body">




                    <h5>REQUESTOR DETAILS</h5>
                    <br>
                    <div class="row">

                        <div class="col">
                            <label><b>Request Reference</b></label>
                            <p>{{ UpdateRequest?.reference }}</p>
                        </div>
                        <div class="col">
                            <label><b>Requester Name</b></label>
                            <p>{{ UpdateRequest?.requesterName }}</p>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Requester Function</b></label>
                            <p>{{ UpdateRequest?.requesterFunction }}</p>
                        </div>
                        <div class="col">
                            <label><b>Requester Unit</b></label>
                            <p>{{ UpdateRequest?.requesterUnit }}</p>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Requester Designation</b></label>
                            <p>{{ UpdateRequest?.requesterDesignation }}</p>
                        </div>
                        <div class="col">
                            <label><b>Request Date</b></label>
                            <p>{{ UpdateRequest?.requestDate | date: 'dd MMMM yyyy' }}</p>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col">
                            <label><b>Reason For Vacancy</b></label>
                            <p>{{ UpdateRequest?.reasonForVacancy }}</p>
                        </div>
                        <div class="col">
                            <label><b>Job Title</b></label>
                            <p>{{ UpdateRequest?.jobTitle }}</p>
                        </div>

                    </div>
                </div>

                <!-- <hr *ngIf="!editing"> -->

                <!-- Non Editable View -->
                <!-- <div class="card-body" *ngIf="!editing">
          <div class="row">

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Contract Duration (Month)</b></label>
              <p>{{ UpdateRequest?.contractDuration }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Expected Start Date</b></label>
              <p>{{ UpdateRequest?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Number of Staff</b></label>
              <p>{{ UpdateRequest?.noOfStaff }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Medical Notes </b></label>
              <p>{{ UpdateRequest?.medicalNotes  }}</p>
            </div>

            <div class="col">
              <label><b> Active Number of Employees</b></label>
              <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
            </div>
          </div>


          <div class="row">

            <div class="col">
              <label><b>Budget Cost</b></label>
              <p>{{ UpdateRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
            </div>

            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ UpdateRequest?.createdBy }}</p>
            </div>
          </div>

         
         

          </div> -->
                <div class="card-body">
                    <div class="row">

                        <div class="col">
                            <label><b>N + 1 Designation</b></label>
                            <p>{{ UpdateRequest?.nPlus1Designation }}</p>
                        </div>

                        <div class="col">
                            <label><b>Band</b></label>
                            <p>{{ UpdateRequest?.band }}</p>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Cost Center</b></label>
                            <p>{{ UpdateRequest?.costCenter }}</p>
                        </div>
                        <div class="col">
                            <label><b>Location</b></label>
                            <p>{{ UpdateRequest?.location }}</p>
                        </div>


                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Date Vacancy Occured</b></label>
                            <p>{{ UpdateRequest?.dateVacancyOccurred | date: 'dd MMMM yyyy'}}</p>
                        </div>

                        <div class="col">
                            <label><b>Required Number</b></label>
                            <p>{{ UpdateRequest?.requiredNumber }}</p>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Type Of Vacancy</b></label>
                            <p>{{ UpdateRequest?.typeOfVacancy }}</p>
                        </div>
                        <div class="col">
                            <label><b>Reason For Vacancy</b></label>
                            <p>{{ UpdateRequest?.reasonForVacancy }}</p>
                        </div>



                    </div>
                    <div class="row">
                        <div class="col">
                            <label><b>Mode Of Recruitment</b></label>
                            <p>{{ UpdateRequest?.modeOfRecruitment }}</p>
                        </div>

                        <div class="col">
                            <label><b>Duration Of Contract</b></label>
                            <p>{{ UpdateRequest?.durationOfContract }}</p>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col">
                            <label><b>Estimated Annual Cost</b></label>
                            <p>{{ UpdateRequest?.estimatedAnnualCost }}</p>
                        </div>

                        <div class="col">
                            <label><b>Justification For Vacancy</b></label>
                            <p>{{ UpdateRequest?.justificationForVacancy }}</p>
                        </div>

                    </div>
                    <div class="row">

                        <div class="col">
                            <label><b>Request Date</b></label>
                            <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
                        </div>

                        <div class="col">
                            <label><b>Educational Qualification</b></label>
                            <p>{{ UpdateRequest?.qualification }}</p>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Skills Required</b></label>
                            <p>{{ UpdateRequest?.skillsRequired }}</p>
                        </div>

                        <div class="col">
                            <label><b>Experience</b></label>
                            <p>{{ UpdateRequest?.experience }}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <label><b>Syetem Requirements</b></label>
                            <p>{{ UpdateRequest?.systemRequired }}</p>
                        </div>

                        <div class="col">
                            <label><b>Requested By</b></label>
                            <p>{{ UpdateRequest?.createdBy }}</p>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col">
                            <label><b>Other System Required</b></label>
                            <p>{{ UpdateRequest?.otherSystemRequirements }}</p>
                        </div>
                    </div>

                    <hr *ngIf="ViewlevelOfCompliance">
                    <div class="row" *ngIf="ViewlevelOfCompliance">
                        <div class="col">
                            <label><b>Approved Budget For The Department</b></label>
                            <p>{{ UpdateRequest?.presentDepartmentManpowerFigure }}</p>
                        </div>
                        <div class="col">

                            <label><b>Present Manpower Figure For The Department</b></label>
                            <p>{{ UpdateRequest?.presentDepartmentManpowerFigure }}</p>
                        </div>
                        <div class="col">
                            <label><b>Level of Risk Exposure(Compliance)</b></label>
                            <br>
                            <p [ngClass]="getColor(UpdateRequest?.levelOfExposureCompliance)">{{ UpdateRequest?.levelOfExposureCompliance }} </p>
                        </div>
                    </div>
                    <div class="row" >
                        <div class="col">
                          <div class="col pull right" >	
                            <button (click)="getJD(UpdateRequest)">Download Job Description</button>
                          </div>
                          
                        </div>
            
                        <div class="col">
                          <div class="col pull right" >	
                          <nz-space>
                             
                              <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument(UpdateRequest)">View document</button>
                            </nz-space>
                      </div>
                    </div>
            

                </div>
                <hr>
                <div class="card-body">
                    <h5 class="card-title">Approvals</h5>
                    <div class="table-responsive" *ngIf="ManPowerRequestApprovals?.length">
                        <table class="table table--striped table-hover">
                            <thead>
                                <tr>
                                    <th>
                                        Designation Name
                                    </th>
                                    <th>
                                        Approved By
                                    </th>
                                    <th>
                                        Date Approved
                                    </th>
                                    <th>
                                        Message
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let approval of ManPowerRequestApprovals">
                                    <td>{{approval.designationName}}</td>
                                    <td>{{approval.approvedBy}}</td>
                                    <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
                                    <td>{{approval.message}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="!ManPowerRequestApprovals?.length" style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
                        <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
                    </div>

                </div>
            </div>

<!-- Cancel Request Modal  -->
<nz-modal  [(nzVisible)]="isCancelVisible" nzTitle="Cancel Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification"><b>Comment</b></label>
        <textarea class="form-control" id="cancelComment" name="cancelComment" [(ngModel)]="cancelComment"
          required>
        </textarea>
      </div>
  
    
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-danger" (click)="cancelRequest()" [disabled]="isChangeOkLoading">Cancel Request</button>
    </div>
  
  </nz-modal>

            <!-- View Pending Request Approval Modal  -->
            <nz-modal [(nzVisible)]="isPendingpprovalModalVisible" nzTitle="Pending Request Approval" [nzWidth]="800" (nzOnCancel)="handleCancel()" (nzOnOk)="handleSubmit()" nzOkText="Send Reminder">

                <div *nzModalContent>

                    <div class="table-responsive">
                        <table class="table table--striped table-hover">
                            <thead>
                                <tr>

                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Designation
                                    </th>
                                    <th>
                                        Status
                                    </th>

                                    <th>
                                        Approval Date
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let approval of ManPowerPendingRequestApprovals">

                                    <td>{{approval.name}}</td>
                                    <td>{{approval.designation }}</td>
                                    <td>{{approval.status}}</td>
                                    <td>{{approval.approvalDate | date: 'dd/MM/yyyy'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- <Button class="btn btn-primary" style="color: white"  loading={loadings[0]}>
                        Click me!
                      </Button> -->
                </div>
               
            </nz-modal>
        </div>
        <!-- Side swipe content -->
        <ng-template #footerTpl>
            <div style="float: right" class="d-print-none">

                <button class="btn btn-primary" style="margin-right: 8px;" (click)="print(UpdateRequest?.reference, 'detailSection')" *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'">Print</button>
                <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>
         
                    </div>


        </ng-template>